import { Component, input } from '@angular/core';
import { UwIcon } from '../icon/uw-icon';
import type { WorkflowStep } from '../../../core/models/navigation.model';

@Component({
  selector: 'uw-workflow-stepper',
  standalone: true,
  imports: [UwIcon],
  template: `
    <div class="flex items-center gap-0 overflow-x-auto" role="navigation" aria-label="Underwriting workflow">
      @for (step of steps(); track step.key; let i = $index) {
        @if (i > 0) {
          <div
            class="mx-1.5 h-px w-5 shrink-0"
            [class]="i <= activeIndex() ? 'bg-success/60' : 'bg-line-strong'"
          ></div>
        }
        <div class="flex shrink-0 items-center gap-2" [attr.data-state]="stateOf(i)">
          <span
            class="flex h-5 w-5 items-center justify-center rounded-full text-[10px] font-bold"
            [class]="
              stateOf(i) === 'done'
                ? 'bg-success text-white'
                : stateOf(i) === 'current'
                  ? 'bg-accent text-white ring-2 ring-accent/30'
                  : 'bg-line text-text-muted'
            "
          >
            @if (stateOf(i) === 'done') {
              <uw-icon name="check" [size]="10" />
            } @else {
              {{ i + 1 }}
            }
          </span>
          <span
            class="text-[11px] font-medium whitespace-nowrap"
            [class]="
              stateOf(i) === 'current'
                ? 'text-primary'
                : stateOf(i) === 'done'
                  ? 'text-secondary'
                  : 'text-text-muted'
            "
          >
            {{ step.label }}
          </span>
        </div>
      }
    </div>
  `,
})
export class UwWorkflowStepper {
  readonly steps = input<WorkflowStep[]>([]);
  readonly activeIndex = input(0);

  protected stateOf(index: number): 'done' | 'current' | 'pending' {
    if (index < this.activeIndex()) return 'done';
    if (index === this.activeIndex()) return 'current';
    return 'pending';
  }
}
